import State from '@/classes/case/State'
import Profile from '@/classes/auth/Profile'
import { dateTimeFormat } from '@/utility/utility_functions'

class Comment {
  static DRAFT = 1
  static VALID = 2
  static REVOKED = 3

  constructor (id, text, createdBy, created, state) {
    this.id = id
    this.text = text
    this.createdBy = createdBy
    this.created = created
    this.state = state
  }

  static asComments (json) {
    return json.map(jsonCase => {
      return Comment.asComment(jsonCase)
    })
  }

  static asComment (json) {
    return new Comment(
      json.id,
      json.text,
      json.created_by ? Profile.asProfile(json.created_by) : {},
      json.created ? dateTimeFormat(json.created) : dateTimeFormat(new Date()),
      json.state ? State.asState(json.state) : {}
    )
  }

  get isDraft () {
    return this.state.value === Comment.DRAFT
  }

  get isValid () {
    return this.state.value === Comment.VALID
  }

  get isRevoked () {
    return this.state.value === Comment.REVOKED
  }
}

export {
  Comment
}
